import React, { useEffect, useRef, useState } from 'react';
import RomtechLogoHeader from '../components/RomtechLogoHeader';
import LoadingModal from '../components/LoadingModal';
import { useCookies } from 'react-cookie';
import { utils } from '../utils/utils';
import axios from 'axios';
import toastApi from '../lib/toastApi';
import { portalApi } from '../lib/portalApi';
const {versionNumber} = require('../version')

export default function Home() {
	const username = useRef();
	const password = useRef();
	const [showModal, setShowModal] = useState(false);
	const [showLogin, setShowLogin] = useState(true);
	const [cookies, setCookie] = useCookies(
		[
			'ROMTechAT',
			'ROMTechUsername',
			'ROMTechVideoRoomId',
			'ROMTechUserId',
			'userId',
		],
		{ path: '/' }
	);
	const [checked, setChecked] = useState(false);
	const prodDbUrl = 'https://middleware.romtech.com/api';
	const prodQcUrl = 'https://staging-middleware.romtech.com/api';

	const isProdOrQc =
		process.env.NEXT_PUBLIC_REACT_APP_DB_URL === prodDbUrl ||
		process.env.NEXT_PUBLIC_REACT_APP_DB_URL === prodQcUrl;

	useEffect(() => {
		handleLogoutReason();
	}, []);

	useEffect(() => {
		setUserStorage();
	}, []);

	const handleLogoutReason = () => {
		const params = new URLSearchParams(window.location.search);
		const reason = params.get('r');

		if (reason) {
			const reasonMessages = {
				logout: 'Logged out successfully',
				timeout: 'Logged out due to inactivity\nPlease login to continue',
				expired: 'Your session has expired\nPlease login to continue',
				unauthorized: 'Unauthorized\nPlease login to continue',
			};
			toastApi[reason === 'unauthorized' ? 'error' : 'warning'](
				reasonMessages[reason]
			);
		}

		history.pushState(null, '', location.href.split('?')[0]);
	};

	const handleUserLogin = async (loginUrl, credentials) => {
		try {
			setShowModal(true);
			const userData = await utils.post(loginUrl, credentials);
			if (userData.status === 200) {
				const sessionData = await utils.makeUserStoreAfterLogin(
					userData.data.data
				);
				setCookie('ROMTechAT', sessionData.token, { path: '/' });
				setCookie('ROMTechUsername', sessionData.user.username, { path: '/' });
				setCookie('ROMTechUserId', sessionData.user.id, { path: '/' });

				const resp = await portalApi.selectOrInsertObserver(credentials.username, sessionData.token)

				setCookie('userId', resp.data.data.id, { path: '/' });
				setCookie('ROMTechVideoRoomId', resp.data.data.video_room_id, { path: '/' });
				setShowModal(false);
				location.href = '/authorized/observe3';
			} else {
				handleLoginError('Invalid Login');
			}
		} catch (error) {
			handleLoginError('Unauthorized');
		}
	};

	const handleLoginError = (message) => {
		setShowModal(false);
		toastApi.error(message);
		setShowLogin(true);
	};

	const setUserStorage = async () => {
		const oktaAccessData = await utils.getOktaAccessToken();
		if (oktaAccessData) {
			setShowLogin(false);
			handleUserLogin('/login/okta', {
				username: oktaAccessData.state,
				token: oktaAccessData.accessToken,
			});
		} else {
			setShowLogin(true);
		}
	};

	const login = async () => {
		setShowModal(true);
		if (checked) {
			handleUserLogin('/login', {
				username: username.current.value,
				password: password.current.value,
				bypass_okta_login: checked,
			});
		} else {
			try {
				const resp = await axios.post('/api/v1/redirect', {
					username: username.current.value,
					location: window.location.href,
				});

				if (resp.status === 200) {
					setShowModal(false);
					window.location.replace(resp.data.redirectUrl);
				} else {
					handleLoginError('Invalid Login');
				}
			} catch (error) {
				handleLoginError('Unauthorized');
			}
		}
	};

	const handleCheckBox = () => {
		setChecked(!checked);
	};

	const Checkbox = ({ label, value, onChange }) => (
		<label>
			<input type='checkbox' checked={value} onChange={onChange} />
			{label}
		</label>
	);

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<LoadingModal show={showModal} message='Logging in' />
			<RomtechLogoHeader />
			<div className="absolute bottom-0 left-1">
				{versionNumber}
			</div>
			{showLogin && (
				<form onSubmit={handleSubmit}>
					<div className='w-[670px] h-[405px] shadow bg-white mx-auto mt-10 rounded-md flex flex-col items-center'>
						<div className='font-bold text-4xl text-center mt-16'>
							Cardiac Rehab Observer Login
						</div>
						<input
							ref={username}
							className='pl-3 mt-12 border focus:ring-0 focus:outline-none border-[#979797] h-10 w-80 rounded-md'
							placeholder='Username'
						/>
						{checked && (
							<input
								type='password'
								ref={password}
								className='pl-3 mt-5 border focus:ring-0 focus:outline-none border-[#979797] h-10 w-80 rounded-md'
								placeholder='Password'
							/>
						)}
						<button
							onClick={login}
							disabled={showModal}
							className='h-10 mt-5 w-80 text-white bg-gradient-to-r disabled:bg-none disabled:bg-slate-300 from-[#387a99] to-[#5aacc2] rounded-md disabled:scale-95'
						>
							SIGN IN
						</button>
						<br />
						{!isProdOrQc && (
							<Checkbox
								label=' Disable Okta Authentication'
								value={checked}
								onChange={handleCheckBox}
							/>
						)}
					</div>
				</form>
			)}
		</>
	);
}
